var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconUpload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.0004C20.4 14.0004 20 14.4004 20 15.0004V19.0004C20 19.6004 19.6 20.0004 19 20.0004H5C4.4 20.0004 4 19.6004 4 19.0004V15.0004C4 14.4004 3.6 14.0004 3 14.0004C2.4 14.0004 2 14.4004 2 15.0004V19.0004C2 20.7004 3.3 22.0004 5 22.0004H19C20.7 22.0004 22 20.7004 22 19.0004V15.0004C22 14.4004 21.6 14.0004 21 14.0004ZM7.7 8.70039L11 5.40039V15.0004C11 15.6004 11.4 16.0004 12 16.0004C12.6 16.0004 13 15.6004 13 15.0004V5.40039L16.3 8.70039C16.5 8.90039 16.7 9.00039 17 9.00039C17.3 9.00039 17.5 8.90039 17.7 8.70039C18.1 8.30039 18.1 7.70039 17.7 7.30039L12.7 2.30039C12.6 2.20039 12.5 2.10039 12.4 2.10039C12.2 2.00039 11.9 2.00039 11.6 2.10039C11.5 2.20039 11.4 2.20039 11.3 2.30039L6.3 7.30039C5.9 7.70039 5.9 8.30039 6.3 8.70039C6.7 9.10039 7.3 9.10039 7.7 8.70039Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconUpload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconUpload.1232ab0c5dfed781615fd7cfc0b9cb45.svg";